// API related actions
export const FETCHING_INVOICE_DATA = '@@toyota/FETCHING_INVOICE_DATA';
export const FETCHED_INVOICE_DATA = '@@toyota/FETCHED_INVOICE_DATA';
export const FETCHED_INVOICE_DATA_FAILED = '@@toyota/FETCHED_INVOICE_DATA_FAILED';
export const CANCELLING_INVOICE = '@@toyota/CANCELLING_INVOICE';
export const CANCELLED_INVOICE = '@@toyota/CANCELLED_INVOICE';
export const CANCELLED_INVOICE_FAILED = '@@toyota/CANCELLED_INVOICE_FAILED';
export const CREATING_PROVIDER_INVOICES = '@@toyota/CREATING_PROVIDER_INVOICES';
export const CREATED_PROVIDER_INVOICES = '@@toyota/CREATED_PROVIDER_INVOICES';
export const CREATED_PROVIDER_INVOICES_FAILED = '@@toyota/CREATED_PROVIDER_INVOICES_FAILED';
// complementary actions
export const LOAD_INITIAL_DATA = '@@toyota/LOAD_INITIAL_DATA';
export const SAVE_EXCEL_DATA = '@@toyota/SAVE_EXCEL_DATA';
export const CHANGE_DETAILS_IN_INVOICES_LIST_PAGE = '@@toyota/CHANGE_DETAILS_IN_INVOICES_LIST_PAGE';
export const CHANGE_DETAILS_IN_INVOICES_LIST_PAGE_SIZE = '@@toyota/CHANGE_DETAILS_IN_INVOICES_LIST_PAGE_SIZE';
export const ADD_ITEM_IN_LAST_PAGE = '@@toyota/ADD_ITEM_IN_LAST_PAGE';
export const UPDATE_TOTALS = '@@toyota/UPDATE_TOTALS';
export const UPDATE_PART_NAME = '@@toyota/UPDATE_PART_NAME';
